import { LitElement, html, css } from 'lit';
import '../Dialog-Drawer/confirm.js';
import'../Dialog-Drawer/deletemessage.js'
import'../../../components/ChatUIComponent/AddMember.tsx'
import'../SharePopup/SharePopup.js'
import'../../../components/ChatUIComponent/ForwardMessageList.tsx'
import'../Dialog-Drawer/qr-code-dialog.js'
import'../Dialog-Drawer/rating-dialog.js'
import'../Dialog-Drawer/offer-dialog.js'
import'../Dialog-Drawer/cancel-offer-dialog.js'
import'../Dialog-Drawer/cancel-deal-dialog.js'
import'../Dialog-Drawer/wallet-popup.js'
class DrawerDialogService extends LitElement {
  constructor() {
    super();
    this.activeDialogs = [];
    this.activeDrawers = [];
    this.isMobile = window.innerWidth <= 768;

    // Add resize listener to update mobile status
    this.resizeHandler = () => {
      this.isMobile = window.innerWidth <= 768;
      this.requestUpdate();
    };
    window.addEventListener('resize', this.resizeHandler);
  }

  static get styles() {
    return css`
      .dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--popup-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px); /* for Safari support */
}


      .dialog-container {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .dialog-wrapper {
        background: var( --bg-primary-color);
        border-radius: 8px;
        box-shadow: 0px 2px 25px 0px #FFFFFF1A;
        text-align: center;
        position: relative;
        transition: all 0.3s ease;
        padding: 15px;
        max-width: 500px;
        width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 768px) {
         .dialog-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: none;
    border-radius: 16px 16px 0 0;
    max-height: 80vh;
    overflow-y: auto;
    animation: slide-up 0.3s ease;
     box-sizing: border-box;
  }

        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
      }

      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 40px;
        cursor: pointer;
        color: var(--bg-grey-color);
        padding: 5px;
        line-height: 1;
      }
    `;
  }

  static get properties() {
    return {
      activeDialogs: { type: Array },
      activeDrawers: { type: Array },
      isMobile: { type: Boolean }
    };
  }

  disconnectedCallback() {
    // Remove resize listener when component is removed
    window.removeEventListener('resize', this.resizeHandler);
    super.disconnectedCallback();
  }

  openDialog(name, data = {}, options = {}) {
    const dialogConfig = {
      id: options.id || `${name}-${Date.now()}`,
      name,
      data,
      type: 'dialog'
    };

    this.activeDialogs.push(dialogConfig);
    this.requestUpdate();
    return dialogConfig.id;
  }

  openDrawer(name, data = {}, options = {}) {
    const drawerConfig = {
      id: options.id || `${name}-${Date.now()}`,
      name,
      data,
      type: 'drawer'
    };

    this.activeDrawers.push(drawerConfig);
    this.requestUpdate();
    return drawerConfig.id;
  }

  closeDialog(name) {
    if(name){
      this.activeDialogs = this.activeDialogs.filter(dialog => dialog.name !== name);
    }else{
      this.activeDialogs = [];
    }
    this.requestUpdate();
  }

  closeDrawer(name) {
    if(name){
      this.activeDrawers = this.activeDrawers.filter(drawer => drawer.name !== name);
    }else{
      this.activeDrawers = [];
    }
    this.requestUpdate();
  }

  updateDialog(name, data = {}) {
    const dialogIndex = this.activeDialogs.findIndex(dialog => dialog.name === name);
    if (dialogIndex !== -1) {
      this.activeDialogs[dialogIndex].data = { ...this.activeDialogs[dialogIndex].data, ...data };
      this.requestUpdate();
    }
  }

  renderDialogComponent(dialog) {
    switch(dialog.name) {
      case 'confirm-dialog':
        return html`
          <confirm-dialog
            .dialogData=${dialog.data}
            .onClose=${() => this.closeDialog(dialog.name)}
            .isMobile=${this.isMobile}
          ></confirm-dialog>
        `;
      case 'delete-message':
        return html`
          <delete-message
            .dialogData=${dialog.data}
            .onClose=${() => this.closeDialog(dialog.name)}
            .isMobile=${this.isMobile}
          ></delete-message>
        `;
      case 'member-add':
        return html`
         <member-add
         .dialogData=${dialog.data}
          .onClose=${() => this.closeDialog(dialog.name)}
          .isMobile=${this.isMobile}
                ></member-add>
        `
      case 'share-popup':
        return html`
         <share-popup 
         .dialogData=${dialog.data}
          .onClose=${() => this.closeDialog(dialog.name)}
          .isMobile=${this.isMobile}
                ></share-popup>
        `
      case 'forward-memebers':
        return html`
         <forward-memebers 
         .dialogData=${dialog.data}
          .onClose=${() => this.closeDialog(dialog.name)}
          .isMobile=${this.isMobile}
                ></forward-memebers>
        `
      case 'cancel-deal-dialog':
        return html`
          <cancel-deal-dialog
            .reasons=${dialog.data.reasons}
            .loading=${dialog.data.loading}
            .error=${dialog.data.error}
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
            .conversationId=${dialog.data.conversationId}
            .orderId=${dialog.data.orderId}
            .token=${dialog.data.token}
          ></cancel-deal-dialog>
        `;
      case 'qr-code-dialog':
        return html`
          <qr-code-dialog
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
          ></qr-code-dialog>
        `;
      case 'rating-dialog':
        return html`
          <rating-dialog
            .token=${dialog.data.token}
            .conversationId=${dialog.data.conversationId}
            .orderId=${dialog.data.orderId}
            .rateType=${dialog.data.rateType}
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
          ></rating-dialog>
        `;
      case 'offer-dialog':
        return html`
          <offer-dialog
            .type=${dialog.data.type}
            .productImage=${dialog.data.productImage}
            .productTitle=${dialog.data.productTitle}
            .productPrice=${dialog.data.productPrice}
            .currentOfferPrice=${dialog.data.currentOfferPrice}
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
          ></offer-dialog>
        `;
      case 'cancel-offer-dialog':
        console.log('Rendering cancel-offer-dialog with data:', dialog.data);
        return html`
          <cancel-offer-dialog
            .reasons=${dialog.data.reasons}
            .loading=${dialog.data.loading}
            .error=${dialog.data.error}
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
            .conversationId=${dialog.data.conversationId}
            .offerId=${dialog.data.offerId}
            .token=${dialog.data.token}
            .isExchangeOffer=${dialog.data.isExchangeOffer}
            .exchangeAssetId=${dialog.data.exchangeAssetId}
          ></cancel-offer-dialog>
        `;
      case 'wallet-popup':
        return html`
          <wallet-popup
            .onConfirm=${dialog.data.onConfirm}
            .onCancel=${dialog.data.onCancel}
          ></wallet-popup>
        `;
      default:
        console.error(`No render method for dialog: ${dialog.name}`);
        return html``;
    }
  }


  closeAll(){
    this.closeDialog();
    this.closeDrawer();
  }

  render() {
    const renderItems = [...this.activeDialogs, ...this.activeDrawers];
    if (renderItems.length === 0) return html``;

    return html`
     <div class='dialog' >
      <div 
        class="dialog-container" 
        @click=${() => this.closeAll()}
      >
        ${renderItems.map(item => html`
          <div 
            class="dialog-wrapper" 
            @click=${this.stopPropagation}
          >
            <button 
              class="close-button" 
              @click=${() =>  this.closeDialog(item.name)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
            </button>
            ${item.type === 'dialog' 
              ? this.renderDialogComponent(item)
              : this.renderDrawerComponent(item)
            }
          </div>
        `)}
      </div>
     </div>
    `;
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
}

// Define the custom element for the service
customElements.define('drawer-dialog-service', DrawerDialogService);

// Create and export singleton instance
export const drawerDialogService = document.createElement('drawer-dialog-service');
document.body.appendChild(drawerDialogService);